(() => {
  const SELECTOR = '[data-p360-root]';

  function showToast(root, message) {
    const toast = root.querySelector('[data-p360-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(toast._p360Timer);
    toast._p360Timer = window.setTimeout(() => toast.classList.remove('is-visible'), 2200);
  }

  async function refreshCartCount() {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('#cart-drawer-toggle .thb-item-count').forEach(node => {
        node.textContent = cart.item_count > 99 ? '*' : String(cart.item_count);
      });
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
    } catch (error) {
      // Produsul este deja adăugat; actualizarea vizuală a coșului poate fi reluată la următoarea navigare.
    }
  }

  async function addProduct(root, button) {
    const variantId = Number(button.dataset.variantId);
    const productName = button.dataset.productName || 'Produsul';
    if (!variantId || button.disabled) return;

    const initialMarkup = button.innerHTML;
    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = 'Se adaugă…';

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });

      if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        throw new Error(payload.description || 'Produsul nu a putut fi adăugat.');
      }

      button.classList.remove('is-loading');
      button.classList.add('is-added');
      button.textContent = 'Adăugat ✓';
      showToast(root, `${productName} a fost adăugat în coș`);
      await refreshCartCount();
    } catch (error) {
      button.classList.remove('is-loading');
      button.textContent = 'Încearcă din nou';
      showToast(root, error.message || 'A apărut o eroare. Încearcă din nou.');
    }

    window.setTimeout(() => {
      button.disabled = false;
      button.classList.remove('is-added', 'is-loading');
      button.innerHTML = initialMarkup;
    }, 1700);
  }

  function init(root) {
    if (!root || root.dataset.p360Ready === 'true') return;
    root.dataset.p360Ready = 'true';
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-p360-add]');
      if (button && root.contains(button)) {
        addProduct(root, button);
        return;
      }

      const card = event.target.closest('[data-p360-product-url]');
      if (!card || !root.contains(card) || event.target.closest('a, button, input, select, textarea, label')) return;
      window.location.assign(card.dataset.p360ProductUrl);
    });
  }

  function initAll(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
